import { ref } from 'vue';

/**
 * Shared v3 chrome state (new UI, ui_layout='V2') — the legacy sibling of
 * rm-portal-beta's `useAppChrome`. Module-level singleton so the rail's toggle
 * and the contextual ToC drawer (Phase 2) share one collapse flag.
 */
const sidebarCollapsed = ref(false);

export function useV3Chrome() {
  function setSidebarCollapsed(v) {
    sidebarCollapsed.value = !!v;
  }
  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }
  return { sidebarCollapsed, setSidebarCollapsed, toggleSidebar };
}
